import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { error } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThdMonitoringService {
  public isThdReceived: boolean = false;
  constructor(
    private httpClient: HttpClient 
  ) { }

  receiveThd(){
    this.isThdReceived = true;
  }

  didNotReceiveThd(){
    this.isThdReceived = false;    //change to false after testing
  }

  getThdIsReceived(){
    return this.isThdReceived;
  }

  getThdMonitoringResults(gridElementIds: Array<number>){
    return this.httpClient.post(environment.API_BASE_URL + "application/thdVoltage/getData", gridElementIds);
  }
}
